import { useState, useEffect } from 'react';
import Icon from '@mdi/react';
import { mdiAlert } from '@mdi/js';
import { ContactPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import { useGetPerson } from '@my-pages/hooks/useGetPerson';
import {smoothScroll} from "@shared/utils/misc.ts";
import Alerts from "@shared/components/Alerts.tsx";
import ContactForm from "@my-pages/features/contact/components/ContactForm.tsx";
import ContactInformation from "@my-pages/features/contact/components/ContactInformation.tsx";


interface IContactPage {
    content: ContactPageContentResponseModel;
}

const ContactPage = ({ content }: IContactPage) => {
    const member = useGetPerson();
    const [displayForm, setDisplayForm] = useState(false);

    useEffect(() => {
        smoothScroll(0);
    }, [displayForm]);

    return (
        <>
            <h1 className='page-title'>Kontaktuppgifter</h1>
            <div className='slide-up-fade-in'>
                {content?.properties?.importantMessages && (
                    <div className='mb-4'>
                        <Alerts alerts={content?.properties?.importantMessages} />
                    </div>
                )}
                <div className='card card-body mb-4'>
                    <div className='row'>
                        <div className='col-12'>
                            {member ? (
                                <>{displayForm ? <ContactForm closeForm={() => setDisplayForm(false)} /> : <ContactInformation openForm={() => setDisplayForm(true)} />}</>
                            ) : (
                                <div
                                    className='alert alert-danger mb-5'
                                    role='alert'
                                >
                                    <h5 className='alert-heading'>
                                        <Icon
                                            path={mdiAlert}
                                            className='mdi mr-1'
                                        />
                                        Kunde inte ladda medlemsinformation.
                                    </h5>
                                    <p>Något gick fel när medlemsinformationen skulle laddas, prova ladda om sidan igen.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactPage;
